"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSelectOrDispatch = void 0;
const react_redux_1 = require("react-redux");
const transactions_1 = require("companion-app-components/flux/transactions");
const feature_flags_1 = require("companion-app-components/flux/feature-flags");
const scheduled_transactions_1 = require("companion-app-components/flux/scheduled-transactions");
const accounts_1 = require("companion-app-components/flux/accounts");
const transactionsSelectors = __importStar(require("data/transactions/selectors"));
const actions_1 = require("components/Dialogs/ScheduledTransactionLightEditDialog/actions");
const useSelectOrDispatch = (props) => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const scheduledTransactionsEnabled = (0, react_redux_1.useSelector)((state) => feature_flags_1.featureFlagsSelectors.getFeatureFlag(state, 'scheduledTransactions'));
    const scheduledTransactions = (0, react_redux_1.useSelector)((state) => scheduled_transactions_1.scheduledTransactionsSelectors.getUserVerifiedScheduledTransactions(state));
    const scheduledTransactionByClientId = (0, react_redux_1.useSelector)((state) => scheduled_transactions_1.scheduledTransactionsSelectors.getScheduledTransactionByClientId(state, props.uiState.newScheduledTransactionClientId));
    const scheduledTransactionById = (0, react_redux_1.useSelector)((state) => scheduled_transactions_1.scheduledTransactionsSelectors.getScheduledTransactionById(state, props.txForm.stModelId));
    const scheduledTransaction = props.uiState.newScheduledTransactionClientId ? scheduledTransactionByClientId : scheduledTransactionById;
    const scheduledTransactionsError = (0, react_redux_1.useSelector)((state) => scheduled_transactions_1.scheduledTransactionsSelectors.getError(state));
    const transactionsError = (0, react_redux_1.useSelector)((state) => transactionsSelectors.getError(state));
    const transactionDetailsComprehensive = (0, react_redux_1.useSelector)((state) => feature_flags_1.featureFlagsSelectors.getFeatureFlag(state, 'transactionDetailsComprehensive'));
    const showTxnJson = (0, react_redux_1.useSelector)((state) => feature_flags_1.featureFlagsSelectors.getFeatureFlag(state, 'showTxnJson'));
    const coaBucket = (0, react_redux_1.useSelector)((state) => transactionsSelectors.getTransactionBucket(state, props.txForm));
    const txnsByAccountId = (0, react_redux_1.useSelector)((state) => transactionsSelectors.getTransactionsByAccountId(state));
    const accountIds = (0, react_redux_1.useSelector)(accounts_1.accountsSelectors.getAccountsById);
    return {
        scheduledTransactionsEnabled,
        scheduledTransactions,
        scheduledTransaction,
        scheduledTransactionsError,
        transactionsError,
        transactionDetailsComprehensive,
        showTxnJson,
        coaBucket,
        txnsByAccountId,
        accountIds,
        dispatchDeleteScheduledTransactionAction: (data) => dispatch(scheduled_transactions_1.scheduledTransactionsActions.deleteScheduledTransaction(data)),
        dispatchCreateBillScoutScheduleAction: (data) => dispatch(scheduled_transactions_1.scheduledTransactionsActions.createBillScoutSchedule(data)),
        dispatchPerformTransactionAction: (data, meta) => dispatch(transactions_1.transactionsActions.performTransactionAction(data, meta)),
        dispatchScheduledEditLightDialog: (data) => dispatch((0, actions_1.scheduledTransactionLightEditDialog)(data)),
    };
};
exports.useSelectOrDispatch = useSelectOrDispatch;
